import { Link } from 'react-router';
import { HeaderPro } from '../../components/HeaderPro';
import { Footer } from '../../components/Footer';
import { SessionList } from '../../components/SessionList';
import { RequirePro } from '../../../lib/use-auth';

export default function ProSecurityPage() {
  return (
    <RequirePro>
      <div className="min-h-screen bg-white flex flex-col">
        <HeaderPro />

        <main className="flex-1 max-w-[1140px] mx-auto w-full px-4 py-8 md:py-12">
          {/* Back and Title */}
          <div className="flex items-start gap-3 sm:gap-4 mb-8 md:mb-10">
            <Link
              to="/professional/account-settings"
              className="mt-1 w-[40px] h-[40px] bg-[#3a3335]/[0.04] rounded-[10px] flex items-center justify-center hover:bg-[#3a3335]/[0.08] transition-colors shrink-0"
            >
              <span className="material-icons text-[#908e8e] text-[18px]">
                chevron_left
              </span>
            </Link>
            <div>
              <h1 className="font-['Playfair_Display',sans-serif] font-bold text-[#8e2a2f] text-[18px] mb-1">
                Security
              </h1>
              <p className="font-['DM_Sans',sans-serif] text-[#908e8e] text-[14px] tracking-[-0.1px]">
                Your last activity and credentials
              </p>
            </div>
          </div>

          <div className="flex flex-col lg:flex-row justify-between gap-8 lg:gap-12">
            <div className="flex-1 max-w-[640px]">
              <SessionList role="professional" />
            </div>

            <div className="w-full lg:w-[361px] shrink-0">
              <div className="bg-white rounded-[6px] shadow-[0px_3px_4px_0px_rgba(153,155,168,0.15)] p-6 lg:p-8">
                <div className="w-[48px] h-[48px] rounded-[8px] bg-[#3a3335]/[0.04] flex items-center justify-center mb-6">
                  <span className="material-icons text-[#908e8e] text-[22px]">
                    lock
                  </span>
                </div>
                <h3 className="font-['Inter',sans-serif] font-bold text-[#3a3335] text-[16px] leading-[24px] mb-3">
                  Security credentials
                </h3>
                <p className="font-['DM_Sans',sans-serif] text-[#908e8e] text-[14px] leading-[21px] tracking-[-0.1px]">
                  If you see a device you don't recognise, remove it right
                  away — it will be signed out immediately. To end this
                  session, use the Logout button in the menu.
                </p>
              </div>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </RequirePro>
  );
}
